import { render, staticRenderFns } from "./CreateClientCollective.vue?vue&type=template&id=388ec4e2&scoped=true"
import script from "./CreateClientCollective.vue?vue&type=script&lang=js"
export * from "./CreateClientCollective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388ec4e2",
  null
  
)

export default component.exports